/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_EmptyInputs */

const en_admin_invite_codes_empty = /** @type {(inputs: Admin_Invite_Codes_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No invite codes yet`)
};

/**
* | output |
* | --- |
* | "No invite codes yet" |
*
* @param {Admin_Invite_Codes_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_empty = /** @type {((inputs?: Admin_Invite_Codes_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_empty(inputs)
});
export { admin_invite_codes_empty as "admin.invite_codes.empty" }